import { AngebotsId } from './angebotsId';

export enum ProdukttabelleEnum {
  RS_VERKEHR = 'RS_VERKEHR',
  TKV_HUND_KATZE = 'TKV_HUND_KATZE',
  TKV_PFERD = 'TKV_PFERD',
  TKV_V2_HUND_OPSCHUTZ = 'TKV_V2_HUND_OPSCHUTZ',
  TKV_V2_KATZE_OPSCHUTZ = 'TKV_V2_KATZE_OPSCHUTZ',
  TKV_V2_PFERD_OPSCHUTZ = 'TKV_V2_PFERD_OPSCHUTZ',
  TKV_V2_HUND_VOLLSCHUTZ = 'TKV_V2_HUND_VOLLSCHUTZ',
  TKV_V2_KATZE_VOLLSCHUTZ = 'TKV_V2_KATZE_VOLLSCHUTZ',
  TKV_V2_PFERD_VOLLSCHUTZ = 'TKV_V2_PFERD_VOLLSCHUTZ',
}

export interface ProduktRequested extends AngebotsId {
  produkttabelle?: ProdukttabelleEnum;
  /**
   * Set when the request only exists to reload the accompanying catalogs (Tierrassen,
   * Krankheiten, Gesundheitszustand) after a saved offer was restored. The masterprodukt
   * itself must not be reloaded in that case, because the restored state already contains
   * it and overwriting it would discard the saved Produktlinien selection.
   */
  catalogsOnly?: boolean;
  /**
   * Set by the Tiergruppe (TGV): it loaded the catalogs (Tierrassen, Krankheiten) once on its
   * first page and wrote them into the offer it requests the product for. The apps that load
   * them on every product request must not do it again, once for each offer of the group.
   */
  catalogsProvided?: boolean;
  /**
   * Set by the Tiergruppe (TGV) when the Gesundheitszustand list that belongs to the product is
   * in the checkout already or was requested with an earlier product of the group. The lists are
   * the same for all offers of an animal type.
   */
  healthStatusLoaded?: boolean;
  /**
   * Set when one offer of a Tiergruppe requests the catalogs for all the offers of its group
   * after a Vorgang was loaded. The answers are broadcast to all stores, so only the store of
   * this offer answers; the other stores of the group do not ask again.
   */
  catalogsForGroup?: boolean;
}
